import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.interface';
import { CarType, CreateCarTypeDto, UpdateCarTypeDto } from '../models/car-type.model';

@Injectable({
  providedIn: 'root'
})
export class CarTypesService {
  private baseUrl = '/api/company/car-types';

  constructor(private http: HttpClient) {}

  getCarTypes(): Observable<ApiResponse<CarType[]>> {
    return this.http.get<ApiResponse<CarType[]>>(this.baseUrl);
  }

  getCarTypeById(id: number): Observable<ApiResponse<CarType>> {
    return this.http.get<ApiResponse<CarType>>(`${this.baseUrl}/${id}`);
  }

  createCarType(dto: CreateCarTypeDto): Observable<ApiResponse<CarType>> {
    return this.http.post<ApiResponse<CarType>>(this.baseUrl, dto);
  }

  updateCarType(id: number, dto: UpdateCarTypeDto): Observable<ApiResponse<CarType>> {
    return this.http.put<ApiResponse<CarType>>(`${this.baseUrl}/${id}`, dto);
  }

  deleteCarType(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
